export function quickBooksAccountingNeedsReconnect(status: {
  clientConfigured?: boolean;
  connected?: boolean;
  tokenHealthy?: boolean;
  needsReconnect?: boolean;
} | null | undefined): boolean {
  if (status == null || status.clientConfigured !== true) {
    return false;
  }
  if (status.needsReconnect === true) {
    return true;
  }
  if (status.connected === true && status.tokenHealthy === false) {
    return true;
  }
  return status.connected !== true;
}

export function quickBooksAccountingNeedsReconnectSoon(status: {
  clientConfigured?: boolean;
  connected?: boolean;
  tokenHealthy?: boolean;
  needsReconnect?: boolean;
  needsReconnectSoon?: boolean;
} | null | undefined): boolean {
  if (status == null || status.clientConfigured !== true) {
    return false;
  }
  if (quickBooksAccountingNeedsReconnect(status)) {
    return false;
  }
  return status.needsReconnectSoon === true;
}

export function quickBooksAccountingOAuthBannerVisible(status: {
  clientConfigured?: boolean;
  connected?: boolean;
  tokenHealthy?: boolean;
  needsReconnect?: boolean;
  needsReconnectSoon?: boolean;
} | null | undefined): boolean {
  return quickBooksAccountingNeedsReconnect(status) || quickBooksAccountingNeedsReconnectSoon(status);
}

export function formatQuickBooksAccountingRefreshExpiry(iso: string | null | undefined): string | null {
  if (iso == null || iso.trim() === "") {
    return null;
  }
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function quickBooksAccountingBannerMessage(
  status: {
    connected?: boolean;
    tokenHealthy?: boolean;
    needsReconnectSoon?: boolean;
    refreshTokenExpiresAt?: string | null;
  } | null | undefined,
  statusUnavailable: boolean,
): string {
  if (statusUnavailable) {
    return "QuickBooks Online connection status could not be loaded.";
  }
  if (status?.connected && status.tokenHealthy === false) {
    return "QuickBooks Online sign-in expired — commission journal entries and other accounting writes are paused until you reconnect.";
  }
  if (status?.needsReconnectSoon === true) {
    const expiryLabel = formatQuickBooksAccountingRefreshExpiry(status.refreshTokenExpiresAt);
    if (expiryLabel != null) {
      return `QuickBooks Online sign-in expires on ${expiryLabel} — reconnect soon to avoid interrupting commission journal entries and other accounting writes.`;
    }
    return "QuickBooks Online sign-in expires soon — reconnect to avoid interrupting commission journal entries and other accounting writes.";
  }
  return "QuickBooks Online is not connected — commission journal entries and other accounting writes are paused until you connect.";
}
